import { connect } from 'preact-redux'
import cx from 'classnames'

import NewPaybarPersonalFieldsetBase from '../newPaybarPersonalFieldsetBase'
import NewPaybarTelegramInput from '../newPaybarTelegramInput'
import { TextNode, Heading3 } from '../../textNodes'
import { FormInput } from '../../form'

import {
  addDirtyForm,
  removeDirtyForm,
  setFormValidity,
  changePaymentMethodToPreviousCard,
  changePaymentMethodToInvoice,
} from '../newPaybarActions'

const Row = ({ children }) => (<label className="newPaybarPersonalFieldset-row">{ children }</label>)

const Label = ({ name }) => (
  <TextNode className="newPaybarPersonalFieldset-label">
    { I18n.t(`newPaybar.vacancy.${name}`) }
  </TextNode>
)

const TextInput = ({ ...props }) => (
  <FormInput
    className="newPaybarPersonalFieldset-input"
    type="text"
    { ...props } />
)

const PaymentMethodSwitch = ({ paymentMethod, onSetCard, onSetInvoice }) => {
  const cardSelectorItemClass = cx('newPaybarSwitch-selectorItem', { is__active: paymentMethod !== 'invoice' })
  const invoiceSelectorItemClass = cx('newPaybarSwitch-selectorItem', { is__active: paymentMethod === 'invoice' })

  return (<div className="newPaybarSwitch">
    <Heading3 className="newPaybarSwitch-heading">
      { I18n.t('newPaybar.vacancy.paymentMethod.label') }
    </Heading3>
    <div className="newPaybarSwitch-selector">
      <span className={ cardSelectorItemClass } onClick={ onSetCard }>
        { I18n.t('newPaybar.vacancy.paymentMethod.card') }
      </span>
      <span className={ invoiceSelectorItemClass } onClick={ onSetInvoice }>
        { I18n.t('newPaybar.vacancy.paymentMethod.invoice') }
      </span>
    </div>
  </div>)
}

class NewPaybarPersonalFieldset extends NewPaybarPersonalFieldsetBase {
  constructor(props) {
    super(props)

    this.validityStates = {
      payerName: !!this.props.userName,
      organization: !!this.props.userOrganization,
      profession: !!this.props.userProfession,
      telegram: false,
    }

    this.validityMaps = { self: ['payerName'] }
    this.rememberedHiddenInputs = []
  }

  componentDidUpdate() {
    this.props.setFormValidity({ isValid: this.isValid })
    this.rememberedHiddenInputs.forEach(input => this.remember(input))
    this.saveAgreedToTerms()
  }

  get isInvoicePaymentMethod() {
    return this.props.currentPaymentMethod === 'invoice'
  }

  get isValid() {
    if (!this.isExternalFormValid) return false
    if (this.isInvoicePaymentMethod) return false
    if (this.props.hasTerms && !this.isAgreedToTerms) return false

    return this.validityMaps[this.props.type]
      .every(field => this.validityStates[field])
  }

  get isExternalFormValid() {
    return window.application.newPaybar?.externalForm?.isValid
  }

  inputProps(name) {
    return {
      name,
      key: name,
      onInput: this.onInput,
      onValidityChange: this.onInputValidityChange,
      initialValue: this.rememberedFields[name],
      ref: ref => this.fieldRefs[name] = ref,
    }
  }

  render() {
    return (
      <div className="newPaybarPersonalFieldset" ref={ this.bindEl }>
        { !this.props.userName &&
          <Row>
            <Label name="userName" />
            <TextInput { ...this.inputProps('payerName') } autoComplete="name" required />
          </Row>
        }

        <NewPaybarTelegramInput
          { ...this.inputProps('telegram') }
          initialValue={ this.rememberedFields.telegram || this.props.userTelegram } />

        { !this.props.userOrganization &&
          <Row>
            <Label name="organization" />
            <TextInput { ...this.inputProps('organization') } autoComplete="organization" />
          </Row>
        }

        { !this.props.userProfession &&
          <Row>
            <Label name="profession" />
            <TextInput { ...this.inputProps('profession') } autoComplete="organization-title" />
          </Row>
        }

        <div className="newPaybarPersonalFieldset-row is__switch">
          <PaymentMethodSwitch
            paymentMethod={ this.props.currentPaymentMethod }
            onSetCard={ this.props.changePaymentMethodToPreviousCard }
            onSetInvoice={ this.props.changePaymentMethodToInvoice } />

          <input type="hidden" name="paymentMethod" value={ this.props.currentPaymentMethod } />
        </div>

        { this.isInvoicePaymentMethod &&
          <TextNode html={ I18n.t('newPaybar.vacancy.paymentMethod.placeholder') } />
        }
      </div>
    )
  }
}

const mapDispatchToProps = {
  setFormValidity,
  addDirtyForm,
  removeDirtyForm,
  changePaymentMethodToPreviousCard,
  changePaymentMethodToInvoice,
}

const mapStateToProps = ({ newPaybar }) => {
  return {
    userName: newPaybar.userName,
    userTelegram: newPaybar.userTelegram,
    userOrganization: newPaybar.userOrganization,
    userProfession: newPaybar.userProfession,
    isAgreedToTerms: newPaybar.isAgreedToTerms,
    isVisible: newPaybar.isVisible,
    subscription: newPaybar.subscription,
    product: newPaybar.product,
    currentPaymentMethod: newPaybar.currentPaymentMethod,
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(NewPaybarPersonalFieldset)
